import useSWR from "swr";
import { fetchTacticMovies } from "@/repositories/tacticMovie";
import { useEffect } from "react";

export const Movie = ({
  tactic_id,
  isEmpty,
}: {
  tactic_id: string;
  isEmpty: (data: boolean) => void;
}) => {
  const { data } = useSWR(
    `/api/v1/tactic_movies?tactic_id=${tactic_id}`,
    (url) => fetchTacticMovies(url)
  );

  useEffect(() => {
    if (data) {
      isEmpty(data.length <= 0);
    }
  }, [data, isEmpty]);

  return (
    <>
      {data &&
        data[0]?.vimeo_id &&
        (data[0]?.vimeo_id.includes("youtube") ? (
          <div className={"aspect-video m-auto max-w-[1280px] relative"}>
            <iframe
              width="900"
              height="507"
              src={data[0]?.vimeo_id}
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              className={"absolute top-0 left-0 w-full h-full"}
            />
          </div>
        ) : (
          <div className={"aspect-video m-auto max-w-[1280px] relative"}>
            <iframe
              className={"absolute top-0 left-0 w-full h-full"}
              src={`https://player.vimeo.com/video/${data[0]?.vimeo_id}`}
              width="900"
              height="507"
              allow="autoplay; fullscreen"
            />
          </div>
        ))}
    </>
  );
};
